/**
 * THIS FILE IS GENERATED, DO NOT DIRECTLY EDIT
 */
import { ContractMarketInfo } from '@ui/services/contract/hooks/TradingReaderFacet/useGetMarketInfos/types';
import { ChainId } from '@ui/types/chain';

export const market_info_raw = {
  10143: [
    {
      pairBase: '0xcf5a6076cfa32686c0Df13aBaDa2b40dec133F1d',
      longQty: { __type: 'bigint', value: '4041159806' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '59813256800444067642522' },
      fundingFeeRate: { __type: 'bigint', value: '3333333333' },
      lastLongAccFundingFeePerShare: {
        __type: 'bigint',
        value: '-12263767379407723',
      },
    },
    {
      pairBase: '0xB5a30b0FDc5EA94A52fDc42e3E9760Cb8449Fb37',
      longQty: { __type: 'bigint', value: '5585245553' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '1784148610211319000000' },
      fundingFeeRate: { __type: 'bigint', value: '3333333333' },
      lastLongAccFundingFeePerShare: {
        __type: 'bigint',
        value: '-1810883333152245',
      },
    },
    {
      pairBase: '0x0a3ec4fc70EaF64fAf6EeDa4e9b2Bd4742a78546',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xaEb724422620edb430DCAf22aEeFF2E9388a578c',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x0000000000000000000000000000000000000003',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x0000000000000000000000000000000000000004',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x3a54a9A690616Fbc26CfC409BF11F89d51f1d57a',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x6C755094F1Cdd95e2e4170549dc12e7555151536',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xB2023082F01404DD0CE6937cAb03C4f5d6db9bA8',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x9a4f772DE1a5F6DF5913fA2C98dD7177eaA23Dc2',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x0A8F1F385feD9c77A2e0daA363cCc865e971bdBE',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xE108948b9667048232851F26A1427d3a908B22da',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x0057355892FAB25DdC63a7482eC1696D6aDa6703',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x7C687a3207CD9c05B4b11d8DD7Ac337919c22001',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x5cCc5C04130D272Bf07D6e066f4caE40CFC03136',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xb589511C51D1fFdA5D943Ac1c9733e112aBEfF7B',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xcb8900160Bd4A86D3b80f5ad5A44EE15823B0592',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xA9226449042E36BF6865099eEC57482aa55E3aD0',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x35b8BAfFF3570683Af968B8D36B91b1a19465141',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
      longQty: { __type: 'bigint', value: '2718646594469301' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '18914768022504701' },
      fundingFeeRate: { __type: 'bigint', value: '3333333333' },
      lastLongAccFundingFeePerShare: {
        __type: 'bigint',
        value: '-3520473332981286',
      },
    },
    {
      pairBase: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb',
      longQty: { __type: 'bigint', value: '60424255651' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '491998305199620000000' },
      fundingFeeRate: { __type: 'bigint', value: '3333333333' },
      lastLongAccFundingFeePerShare: {
        __type: 'bigint',
        value: '-1881246666478542',
      },
    },
    {
      pairBase: '0x721d0151AC1740353C14798db0C464B8C0116cc3',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x232CE3bd40fCd6f80f3d55A522d03f25Df784Ee2',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xa5E34D2f9b8f4A05d531B5CC03e06624285B7A00',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xE9d95d048d2A009f6286570e4ad419Dbba8490EF',
      longQty: { __type: 'bigint', value: '235708731874082' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '168675100095074944' },
      fundingFeeRate: { __type: 'bigint', value: '3333333333' },
      lastLongAccFundingFeePerShare: {
        __type: 'bigint',
        value: '-1881576666478509',
      },
    },
    {
      pairBase: '0x6Df098aC2087Ddd7401A9A9F19e0D60D4f07BB17',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xC5f3D8462b1Cf323F17cd65568a8349b94a47e41',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x062e57BcF79Ec1579Df888E32A3F07Cc899dc60A',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xF4940d379CDb765b9E0430725c0C9Efb14A767ce',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x54b8e78c6c147de36b4914b070365Df449151317',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x3aE04EaB3C283c5516C3958271264Ba9DBafCb4E',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xDF104b3DdF24cECE9843178cCc86A2152B3A4e07',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x3d9Fd1a881e7e0C02c76071F9e565D22A300cC73',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x673187b2142Ef3CfF8A77799A3F207126FF02C55',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xc88Cc73C99870BbA0314F459398b92Ca9BdC5dd6',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xe426Fb9717F3813cc76A3271587d9BEc13875f8D',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0xAD1FA1fDcF0D5E63722D43fb25F8eD3D51D3C074',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x160A9630e8B9343f7fCCdEcF67BF1a59FE8d2B58',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
    {
      pairBase: '0x601e2aa61d4354b3E5dBcB86733Bac211C073A4e',
      longQty: { __type: 'bigint', value: '0' },
      shortQty: { __type: 'bigint', value: '0' },
      lpLongAvgPrice: { __type: 'bigint', value: '0' },
      lpShortAvgPrice: { __type: 'bigint', value: '0' },
      fundingFeeRate: { __type: 'bigint', value: '0' },
      lastLongAccFundingFeePerShare: { __type: 'bigint', value: '0' },
    },
  ],
} as unknown as Record<ChainId, ContractMarketInfo[]>;
